import { useTranslation } from "react-i18next";

export default useTranslation;
